import FireData from './FireData'

import DataHelpers from '../helpers/DataHelpers'

export default class {
    static fetchOpenMilestones(contactKey) {
        return new Promise( (resolve, reject) => {
            let ref = DataHelpers.getTenantRef().child('milestones')
            FireData.fetchItems(ref).then( (milestones) => {
                resolve(milestones)
            })        
        })
    }

}


// WEBPACK FOOTER //
// ./src/data/MilestoneData.js